import { APP_KEY, COMPANY_ID, NEXT } from "@constants/auth.constant";
import { DASHBOARD, INVOICE_LIST } from "@constants/internal-route.constant";
import { AuthService } from "@services/api/Auth.service";
import { LocalStorageService } from "@services/utils/localStorage.service";
import { SessionStorageService } from "@services/utils/sessionStorage.service";
import { ToastService } from "@services/utils/toast.service";

export const appLoginHelper = () => {
	const appKey = SessionStorageService.get(APP_KEY) || null;
	const next = SessionStorageService.get(NEXT) || null;
	const companyId = LocalStorageService.get(COMPANY_ID) || null;
	if (appKey && next) {
		const reqBody = { appKey, companyId };
		AuthService.appLogin(reqBody)
			.then((resp) => {
				if (resp.code === 200) {
					const url = `${next}?uid=${resp?.body?.userId}&appToken=${resp?.body?.accessToken}&cid=${companyId}`;
					window.open(url, "_self");
				}
			})
			// Every non-200 lands here, not in the .then above — the axios response interceptor
			// rejects any body whose code isn't 200. A previous `else if (resp.code === 503)`
			// branch up there was therefore unreachable, leaving the user parked on the
			// "Redirecting to the app…" spinner with nothing but a toast.
			.catch((err) => {
				// 402: the company doesn't hold this module (never subscribed, cancelled, or
				// suspended for an unpaid invoice) — send them to the portal to activate it.
				if (err?.code === 402) {
					window.location.replace(`${DASHBOARD}?reason=${encodeURIComponent(err?.msg || "")}`);
					return;
				}
				// 503: the whole account is suspended — the pending invoice is the way out.
				if (err?.code === 503) {
					window.location.replace(INVOICE_LIST);
					return;
				}
				ToastService.error(err?.msg);
			});
	}
};
